import { IListService } from '@captiveaire/advanceddropdown';
import { QueryService } from '@captiveaire/query';
import { ProxyService } from '../proxy/ProxyService';
import { IGridPagedResult} from '../../src/typings/IGridPagedResult';
import { IHardwareItemSearchCriteria, IHardwareItemSummary } from '../../src/typings/models';
import { IDeviceHardwareItemQueryService } from '../../src/typings/services';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DeviceHardwareItemQueryService implements IDeviceHardwareItemQueryService, IListService {

    public static $name = 'deviceHardwareItemQueryService';

    constructor(
        private queryService: QueryService,
        private proxyService: ProxyService
    ) { }

    public getList(query: IHardwareItemSearchCriteria): angular.IPromise<IGridPagedResult<IHardwareItemSummary>> {
        const sort = (query.ascending) ? 0 : 1;
        const locationId = typeof query.locationId !== 'number' && query.locationId != null ? Number(query.locationId) : query.locationId;
        const moduleId = typeof query.moduleId !== 'number' && query.moduleId != null ? Number(query.moduleId) : query.moduleId;
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getHardwareItemList',
            queryParams: this.queryService.makeRequest(query)
        }).as<IGridPagedResult<IHardwareItemSummary>>();
    }

    /* Not implemented */
    public getEndpointName() {
        return 'hardware-item-update-context';
    }

    public getListItem(id: string): angular.IPromise<IGridPagedResult<IHardwareItemSummary>> {
        // Id must be a number
        const requestId = typeof id !== 'number' ? Number(id) : id;
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getHardwareItemList',
            queryParams: {
                'searchCriteria.id': requestId,
                'searchCriteria.isDevice': true,
                'searchCriteria.pagingCriteria.includeTotalCount': false,
                'searchCriteria.pagingCriteria.skip': 0,
                'searchCriteria.pagingCriteria.sortDirection': 0,
                'searchCriteria.pagingCriteria.sortExpressions': ['Tag'],
                'searchCriteria.pagingCriteria.take': 1
            }
        }).as<IGridPagedResult<IHardwareItemSummary>>();
    }

    public saveHardwareItem(item: IHardwareItemSummary): angular.IPromise<void> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'saveHardwareItem',
            data: item
        }).as<void>();
    }
}
